// import Vue from 'vue'
declare const Vue;
declare const anime;

$(function () {
    /**
     * コンテンツのスクロールエリアの高さを動的に設定し、スクロールできる方に白い影を入れる
     */
    const $scrollArea = $('.js-scroll-contents')
    const $btnArea = $scrollArea.find('.btn-area')
    const $scrollWrap = $scrollArea.find('.contents__scroll-wrap')
    const $scroll = $scrollArea.find('.contents__scroll')
    const $scrollInner = $scrollArea.find('.contents__inner')

    function setHeight () {
        const offset = 30
        const height = $scrollArea.outerHeight() - $btnArea.outerHeight() - offset
        $scroll.css('height', height)

        if ($scrollInner.outerHeight() > $scroll.height()) {
            $scrollWrap.addClass('over')
        } else {
            $scrollWrap.removeClass('over')
        }
    }

    function scrollHandler () {
        if ($scrollWrap.hasClass('over')) {
            if ($scroll.scrollTop() > 0) {
                $scrollWrap.addClass('top') 
            } else {
                $scrollWrap.removeClass('top')
            }
        }
    }

    $scroll.on('scroll', scrollHandler)
    $(window).on('resize', setHeight)

    setHeight()
});


$(function () {
    /**
     * ページ遷移
     */
    const $w = $(window)
    const $wrapper = $('.wrapper')
    const $section = $('.section')

    function setHeight () {
        $wrapper.height(window.innerHeight)
        $section.height($wrapper.height())
    }

    $w.on('resize', setHeight);

    setHeight();
});


$(function () {
    /**
     * メルマガ登録処理
     */
    const app = new Vue({
        el: '#app',
        data () {
            return {
                current: 1,
                maxCount: 4,
                answerList: [],
                checkboxText: '選択して下さい',
                privacyCheck: '',
                resultText: '確認メールを送信しました。<br>メールに記載されているURLをクリックして、登録を完了してください。',
                isSend: false,
                animateFlg: 'right',
                errMsg: '',
                errMsgBirthday: '',
            }
        },
        mounted () {
            setTimeout(() => {
                this.setHeight()
            }, 200)
        },
        methods: {
            prevQuestion () {
                this.animateFlg = 'left'
                this.current--
                setTimeout(() => {
                    this.setHeight()
                }, 200)
            },
            nextQuestion () {
                this.animateFlg = 'right'
                this.current++
                setTimeout(() => {
                    this.setHeight()
                }, 200)
            },
            send () {
                if (this.isSend) {
                    return false
                }
                this.isSend = true

                $.ajax({
                    url: '/magazine/register.php',
                    type: 'post',
                    data: {
                        gender: this.answerList[0],
                        prefectures: this.answerList[1],
                        birthday: this.answerList[2],
                        email: this.answerList[3],
                    }
                }).done((res) => {

                }).fail((res) => {
                    this.resultText = '通信エラーが発生しました。<br>しばらく経ってからお試し下さい。'
                }).always(() => {
                    this.current++
                })
            },
            checkedText (value) {
                const option = $('select[name="prefectures"] option:selected')

                $('select[name="prefectures"] option').prop('selected', false);

                option.prop('selected', true)
                this.checkboxText = option.text()
            },

            checkBirthday() {
                if(this.validateBirthday(this.answerList[2])) {
                    this.nextQuestion()
                }
            },

            validateBirthday(birthday) {
                if (birthday == null || birthday == '') {
                    this.errMsgBirthday = ''
                    return false
                }

                // if (birthday.length !== 8) {
                //     this.errMsgBirthday = '数字8桁で入力して下さい。'
                //     return false
                // }

                var reg = /^[1|2]{1}[0-9]{7}$/;
                console.log(birthday);
                if (!reg.test(birthday)) {
                    this.errMsgBirthday = '生年月日の形式で入力して下さい。'
                    return false
                }

                this.errMsgBirthday = ''
                return true
            },

            validateEmail (email) {
                if (email == null || email == '') {
                    this.errMsg = ''
                    return false
                }
                if (email.length > 256) {
                    this.errMsg = '256文字以内で入力して下さい。'
                    return false
                }
                var reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
                if (!reg.test(email)) {
                    this.errMsg = 'メールアドレスの型式で入力して下さい。'
                    return false
                }

                this.errMsg = ''
                return true
            },
            validate () {
                if (!this.privacyCheck) {
                   return false 
                }
                let isErr = false
                isErr = this.answerList.some((val) => {
                    if (val == null) {
                        return true
                    }
                })
                if (isErr) {
                    return false
                }
                return true // 問題なし
            },
            setHeight () {
                $('.regist').height($('.regist div.active').height())
            }
        },
        filters: {
            gender (value:string) {
                const genders = {
                    "M" : "男性",
                    "F" : "女性",
                    "O" : "その他"
                }
                return genders[value];
            }
        }
    })
})


$(window).on('load', () => {
    /**
     * KVのアニメーション
     */
    const $w = $(window)
    const $wrapper = $('.wrapper')
    const $title = $('.js-title')
    const $subTitle = $('.js-sub-title')
    const $wing = $('.js-kv-wing')
    const $panel = $('.js-panel')
    const $after = $('.js-after')
    const $last = $('.js-last')
    const $wingArea = $('.js-wing-area')
    const className = 'active'

    $w.scrollTop(0)
    $wrapper.css('overflow-y', 'hidden')

    setTimeout(() => {
        $wing.addClass(className)
        $title.addClass(className)
        $subTitle.addClass(className)
        $wingArea.find('.wing').addClass(className)

        setTimeout(() => {
            $panel.addClass(className)
            $wingArea.addClass(className)

            setTimeout(() => {
                $after.addClass(className)
                // $wrapper.css('overflow-y', 'scroll')

                setTimeout(() => {
                    $last.addClass(className)

                    // アニメーションが終わったらtransitionはとっちゃう
                    setTimeout(() => {
                        $title.css('transition', '0s');
                        $panel.css('transition', '0s');
                        $last.css('transition', '0s');
                    }, 100);

                }, 800)

            }, 700)

        }, 2250)
        
    }, 200)
})


$(function () {
    /**
     * 横向きの時に画像を表示
     */
    const $orientation = $(".orientation")

    function checkDirection () {
        var angle: any = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0
        if (angle % 180 !== 0) {
            // ヨコ
            $orientation.show()
        } else {
            // タテ
            $orientation.hide()
        }
    }

    window.addEventListener("orientationchange", checkDirection)
    checkDirection() // 初期表示のチェック
})

window['scrollRegist'] = function () {
    anime({
        targets: '.wrapper',
        scrollTop: $('.wrapper').height() * 2,
        duration: 1500,
        easing: 'easeInOutQuart'
    });
}
